var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"hs-text"}},[_c('div',{staticClass:"hs-text-container"},_vm._l((_vm.baseQuestions),function(baseAnswer,index){return _c('span',{key:index,staticClass:"text-title",class:_vm.isSelectedAnswer(baseAnswer)},[_vm._v(_vm._s(baseAnswer.text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }